/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from 'react-router-dom';
import { Field, Form, Formik, FieldArray } from "formik";
/* import { GlobalAuthContext, GlobalOperationContext } from 'store/context'; */

import DialogComponent from "components/Dialog";
import { Label } from "components/Form";
import { Row, Col } from "components/Grid";
import BrokingSummary from "components/BrokingSummary";
import InputField from "components/Form/InputField";
import Layout from "components/Layout/index";
import SubTitle from "components/SubTitle";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer } from 'components/Button';
import { ButtonContent } from "./styles";
import Button2 from "components/Button2";
import Icon from "components/Icon";
import TagInput from "components/TagInput";
import FileModal from "components/FileModal";

import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext, GlobalOperationContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';

import {
  BoxItems, TextArea, Footer
} from "./styles";
import StepNavigation from "components/StepNavigation/index";
import RenderButtons from 'components/RenderButtons';
import HasPermission from "components/HasPermission/index";

export default function ReSendNbiRequest(props) {

  const [file, setFile] = useState();
  const [nbiMessage, setNbiMessage] = useState("");
  const [summary, setSummary] = useState({});
  const [contacts, setContacts] = useState([]);
  const [historymsg, setHistorymsg] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [attachmentsTag, setAttachmentsTag] = useState([]);
  const [editUrl, setEditUrl] = useState("");
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);
  const operationContext = useContext(GlobalOperationContext);
  const authContext = useContext(GlobalAuthContext);

  /* function handleContacts(contacts) {
    const tag = [];
    if (contacts) {
      contacts.forEach(contact => {
        tag.push(contact.email)
      });
    }
    return tag;
  }; */

  /* const handleAttachments = (attach) => {
    const tag = [];
    attach.forEach(e => {
      tag.push(e.file.fileName);
    })
    setAttachmentsTag(tag);
  }
 */
  function handleBack() {
    history.goBack();
  };

  const goToLoginPage = () => {
    history.push('/login');
  };

  function testJSON(text) {
    if (typeof text !== "string") {
      return false;
    }
    try {
      JSON.parse(text);
      return true;
    }
    catch (error) {
      return false;
    }
  };

  function handleFile() {
    console.log("ID Operation: ", props.match.params.idOperation);

    //fitinsur.setAuthToken("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOjEwMDAsInVzZXJuYW1lIjoic2ltb25AdGV4ZWwuY29tIiwicGVyc29uaWQiOjEyODY4NiwiZmlyc3ROYW1lIjoiU0lNT04iLCJsYXN0TmFtZSI6IkJBS0VSIiwiaWRQZXJzb25Sb290IjoxMDE3MDMsInVzZXJhZG1pbiI6ZmFsc2UsImV4cCI6MTU5NzU4MzU3MywiaWF0IjoxNTk3MTUxNTczfQ.NJAuca1IjDt-WWd43B9q3ZmlhiwNAsHrmA-t7JHiG7M");
    fitinsur.setAuthToken(authContext.token);
    fitinsur.marketSelectionUpdateManually(props.match.params.idOperation, props.match.params.idPersonInsurer)
      .then(a => {
        console.log(a);
        if (a.status !== 200) {
          a.json().then(res => {
            mc.error(res.ret_msg_details);
            history.goBack();
            return;
          })

        } else {
          a.text().then((response) => {
            response = JSON.parse(response);
            console.log('response', response)
            setFile(response.ret_value);
            setEditUrl(response.ret_value[0].lnkAccess);
            /*if (testJSON(response)) {
              response.json().then(res => {
                mc.error(res.ret_msg_details);
                history.goBack();
                return;
              })
            } else {
              setFile(response);
            }*/
          })
        }
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleFile.name}\n` + error);
        console.error('fitPostDocument - Error:', error);
      });
  };

  /* function base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  } */

  /*  function saveByteArray(reportName, byte, t) {
     var blob = new Blob([byte], { type: t });
     var link = document.createElement('a');
     link.href = window.URL.createObjectURL(blob);
     var fileName = reportName;
     link.download = fileName;
     link.click();
   }; */


  function handleSummary() {
    //fitinsur.setAuthToken("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOjEwMDAsInVzZXJuYW1lIjoic2ltb25AdGV4ZWwuY29tIiwicGVyc29uaWQiOjEyODY4NiwiZmlyc3ROYW1lIjoiU0lNT04iLCJsYXN0TmFtZSI6IkJBS0VSIiwiaWRQZXJzb25Sb290IjoxMDE3MDMsInVzZXJhZG1pbiI6ZmFsc2UsImV4cCI6MTU5NzU4MzU3MywiaWF0IjoxNTk3MTUxNTczfQ.NJAuca1IjDt-WWd43B9q3ZmlhiwNAsHrmA-t7JHiG7M");
    fitinsur.setAuthToken(authContext.token);

    fitinsur.requestHeaderNbi(props.match.params.idOperation)
      .then(response => response.json()).then(data => {

        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          return;
        }
        console.log("Sumario-> ", data.ret_value)
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });
        setHistorymsg(data.ret_value.historical);
        setContacts(data.ret_value.contacts);
        setNbiMessage(data.ret_value.nbiSubjectMessage);

        if (data.ret_value.attachments) {
          setAttachments(data.ret_value.attachments);
          /* handleAttachments(data.ret_value.attachments); */
          /* console.log(data.ret_value.attachments)
          let obj = formik.current.values;
          data.ret_value.attachments.forEach(element => {

            obj.attachments.push({ attachment: element.file.fileName })

          });
          formik.current.setValues(obj) */
        }


      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  function handleUpdateManually() {
    window.open(editUrl + "?authContextToken=" + authContext.token + '&renderComponents=true', '_blank');
  };

  //TODO: Alinhar com backend
  const getUpdateManually = () => {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.marketSelectionUpdateManually(props.match.params.idOperation, props.match.params.idPersonInsurer)
      .then(x => x.json())
      .then(res => {
        if (res.ret_code != 200) {
          mc.error(res.ret_msg_details);
          return;
        }
        setEditUrl(res.ret_value.lnkAccess);

      })
  }

  useEffect(() => {
    /*  if (authContext.status !== true) {
       mc.error("User is not authenticated, please Login");
       loading.stop();
       goToLoginPage();
       return;
   }
   else {
       fitinsur.setAuthToken(authContext.token);
       loading.stop();
   }; */
    // getUpdateManually();
    handleSummary();
    handleFile();
  }, []);

  const handleSubmit = () => {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.reSendNbiForm(props.match.params.idOperation, props.match.params.idPersonInsurer)
      .then(x => x.json())
      .then(res => {
        if (res.ret_code != 200) {
          mc.error(res.ret_msg_details);
          return;
        }
        history.goBack();
      })
  }

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.projectName ? summary.projectName : summary?.nmObligor ? summary?.nmObligor : "Broking name"}
      subtitle={summary?.dealCode ? summary?.dealCode : "Deal Code"}
    >
      <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />
      <BrokingSummary data={summary} />
      <ContentCard title="RE-Send NBI Request" icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
        <Col md={12}>

          <FileModal idOperation={props?.match?.params?.idOperation} file={file} />

        </Col>
        <Footer>
          <ButtonContainer>
            <Button forth onClick={() => handleBack()}>&lt; Back</Button>
            <RenderButtons idOperation={props.match?.params?.idOperation}>
              <ButtonContent>
                <HasPermission permission={props.permissions.MARKETS_SELECTION_RESEND}>
                  <Button
                    style={{ marginLeft: "10px", marginTop: "5px" }}
                    onClick={() => handleSubmit()}
                    primary
                    id="btnSubmit"
                  >
                    RE-SEND NBI REQ
                  </Button>
                </HasPermission>
                <HasPermission
                  permission={props.permissions.MARKETS_SELECTION_ANSWER_AS_INSURER}
                >
                  <Button
                    style={{ marginLeft: "10px", marginTop: "5px" }}
                    onClick={() => handleUpdateManually()}
                    primary
                    id="btnSubmit2"
                  >
                    UPDATE MANUALLY
                  </Button>
                </HasPermission>
              </ButtonContent>
            </RenderButtons>
          </ButtonContainer>

        </Footer>
      </ContentCard>
    </Layout>
  );
}
